import type React from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import { Color } from 'shared/utils/colors';
import { BADGE_SIZE } from './constants';

export const accordionSx: SxProps<Theme> = {
  '&:before': { display: 'none' },
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '8px',
  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
  overflow: 'hidden',
};

export const accordionSummarySx: SxProps<Theme> = {
  px: 2,
  py: 1.5,
  minHeight: 'unset',
  backgroundColor: 'grey.100',
  borderBottom: '1px solid',
  borderColor: 'divider',
  '&.Mui-expanded': {
    minHeight: 'unset',
  },
  '&.Mui-focusVisible': {
    bgcolor: 'action.hover',
    boxShadow: 'none',
  },
  '& .MuiAccordionSummary-content': {
    alignItems: 'center',
    gap: 1,
    m: 0,
    '&.Mui-expanded': {
      m: 0,
    },
  },
};

export const headerIconSecondarySx: SxProps<Theme> = {
  color: 'text.secondary',
  flexShrink: 0,
  '&:hover': { color: 'text.secondary' },
  '&.Mui-focusVisible': { color: 'text.secondary', bgcolor: 'action.hover' },
};

// Expand/collapse toggle: needs a clearly visible hover (the neutral default
// reads as "not interactive"), so it picks up the brand-yellow tint.
export const headerToggleIconSx: SxProps<Theme> = {
  color: 'text.secondary',
  flexShrink: 0,
  '&:hover': { color: 'text.primary', bgcolor: Color.primaryOrangeHover },
  '&.Mui-focusVisible': {
    color: 'text.primary',
    bgcolor: Color.primaryOrangeHover,
  },
};

export const headerIconPrimarySx: SxProps<Theme> = {
  color: 'text.primary',
  flexShrink: 0,
  '&:hover': { color: 'text.primary' },
  '&.Mui-focusVisible': { color: 'text.primary', bgcolor: 'action.hover' },
};

export const accordionDetailsSx: SxProps<Theme> = {
  p: 2,
  backgroundColor: 'background.paper',
};

export const getRowWrapperSx = (style: React.CSSProperties): SxProps<Theme> => ({
  mb: 1.5,
  ...style,
});

export const getBadgeSx = (color: string): SxProps<Theme> => ({
  width: BADGE_SIZE,
  height: BADGE_SIZE,
  borderRadius: '50%',
  bgcolor: color,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'text.primary',
  fontWeight: 700,
  fontSize: '0.875rem',
  flexShrink: 0,
});

export const badgeIconSx: SxProps<Theme> = {
  fontSize: 18,
  color: 'inherit',
};

export const badgeIndexSx: SxProps<Theme> = {
  fontSize: 14,
  lineHeight: 1,
  fontWeight: 700,
  color: 'inherit',
};

export const getTitleSx = (hasDisplayName: boolean): SxProps<Theme> => ({
  flex: 1,
  fontWeight: hasDisplayName ? 500 : 400,
  color: hasDisplayName ? 'text.primary' : 'text.secondary',
  fontStyle: hasDisplayName ? 'normal' : 'italic',
});

export const approvalChipSx: SxProps<Theme> = {
  fontWeight: 500,
  mr: 1,
  flexShrink: 0,
};

export const getDragHandleSx = (isDisabled: boolean): SxProps<Theme> => ({
  ...headerIconSecondarySx,
  cursor: isDisabled ? 'not-allowed' : 'grab',
});
